import { ReactNode } from 'react';

import { Box, FlexProps } from '@chakra-ui/react';

import { ContentContainer } from '~/components/container';
import { SectionHeader } from '~/features/experiments/ab_plp_redesign_2025/components/section-header';

export type FeatureCardsSectionProps = {
  sectionPadding?: FlexProps['padding'];
  contentGap?: FlexProps['gap'];
  contentMaxWidth?: 'content-max-width' | 'content-max-width-lg' | 'content-max-width-md' | 'content-max-width-xl';
  headerIcon: ReactNode;
  headerSubtitle: string;
  headerTitle: ReactNode;
  headerDescription: ReactNode;
  headerColor?: string;
  children: ReactNode;
};

export function FeatureCardsSection({
  sectionPadding = { base: '56px 0px', md: '112px 0px' },
  contentGap = '56px',
  contentMaxWidth = 'content-max-width-md',
  headerIcon,
  headerSubtitle,
  headerTitle,
  headerDescription,
  headerColor = 'grey.500',
  children,
}: FeatureCardsSectionProps) {
  return (
    <Box as='section' padding={sectionPadding}>
      <ContentContainer contentMaxWidth={contentMaxWidth} display='flex' flexDirection='column' gap={contentGap}>
        <SectionHeader
          color={headerColor}
          descriptionSlot={headerDescription}
          iconSlot={headerIcon}
          subtitle={headerSubtitle}
          titleSlot={headerTitle}
        />
        {children}
      </ContentContainer>
    </Box>
  );
}
